import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-system-preview',
  templateUrl: './system-preview.component.html',
  styleUrls: ['./system-preview.component.scss'],
  standalone: false,
})
export class SystemPreviewComponent {
  private router: Router = inject(Router);

  nickname!: string;

  @Input() item: any;
  @Input() cartId!: string;
  @Input() currency!: string;
  @Output() itemDeleted: EventEmitter<any> = new EventEmitter<any>();

  goToEditConfiguration(): void {
    this.router.navigate(
      ['/service-configuration'],
      {
        queryParams: {
          'fl-number': this.item.attributes.systemDetails.siemensEquipmentId,
          'rel-product-sysivk': this.item.attributes.systemDetails.materialNumber,
          selectedService: this.item.attributes.abstractSku,
          configId: this.item.attributes.cpqConfigId
        },
      }).then();
  }

  goToConfigurationSummary(): void {
    this.router.navigate(
      ['/configuration-summary'],
      {
        queryParams: {
          'fl-number': this.item.attributes.systemDetails.siemensEquipmentId,
          'rel-product-sysivk': this.item.attributes.systemDetails.materialNumber,
          selectedService: this.item.attributes.abstractSku,
          configId: this.item.attributes.cpqConfigId
        },
      }).then();
  }

  deleteConfiguration(): void {
    this.itemDeleted.emit({sku: this.item.attributes.sku, configId: this.item.attributes.cpqConfigId});
  }
}
